import { usePublicSubscriptionPlans } from "@/hooks/useSubscriptionPlans"
import { buildBetaPricingFaqAnswer } from "@/lib/plan-marketing-copy"
import { contactEmail } from "@/lib/site-links"

export function PricingFaqAnswer() {
  const plans = usePublicSubscriptionPlans()

  if (plans.isPending) {
    return <>Loading plan details…</>
  }

  if (plans.isError) {
    return (
      <>
        During beta, every tier is free of charge. Billing has not launched yet — email {contactEmail} with
        questions.
      </>
    )
  }

  return <>{buildBetaPricingFaqAnswer()}</>
}
